module.exports = __webpack_public_path__ + "static/media/bottlings.a81934f0.jpg";